/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './VerificationLayers.module.scss';

import type { VerificationLayersProps } from './VerificationLayers.types';

export const VerificationLayers = ({ title, description, note, layers, className }: VerificationLayersProps) => (
  <section className={cn(styles.root, className)}>
    <div className={styles.inner}>
      <div className={styles.head}>
        <TitleBlock align="left" theme="dark" title={title} description={description} />
        <div className={styles.note}>{note}</div>
      </div>

      <div className={styles.stack}>
        {layers.map((layer) => (
          <div key={layer.tag} className={styles.layer}>
            <span className={styles.tag}>{layer.tag}</span>
            <h3 className={styles.layerTitle}>{layer.title}</h3>
            <ul className={styles.list}>
              {layer.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);
